import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import Header from "./Header";
import Sidebar from "./Sidebar";
import Dashboard from "./Dashboard/Dashboard";
import BacklinksOffers from "./Backlinks/BacklinksOffers";
import Placement from "./Placement/Placement";
import Imports from "./Imports";
import Exports from "./Exports";
import YourWebsites from "./YourWebsites";
import EditWeb from "./YourWebsites/EditWeb";
import YourContracts from "./YourContracts";
import ContractDetails from "./YourContracts/ContractDetails";
import Cart from "./Cart";
import Articles from "./Articles";
import ImportDetails from "./Imports/Details";
import Orders from "./Orders";
import UpsertArticle from "./Articles/UpsertArticle";
import OrderConfirmation from "./Cart/OrderConfirmation";
import Transactions from "./Transactions";
import AccountSetting from "./AccountSetting";
import Monitor from "./Monitor";
import Balance from "./Balance";
import ScrollToTop from "./Common/ScrollToTop";

function AppMain() {
  return (
    <>
      <Header />
      <Sidebar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/offers-search" element={<BacklinksOffers />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/offers-search/domain/:id" element={<Placement />} />
        <Route path="/cart/confirmation" element={<OrderConfirmation />} />
        <Route path="/contracts/:id" element={<ContractDetails />} />
        <Route path="/websites/:id" element={<EditWeb />} />
        <Route path="/monitor" element={<Monitor />} />
        <Route path="/offers/import" element={<Imports />} />
        <Route path="/offers/import/:id" element={<ImportDetails />} />
        <Route path="/offers/export" element={<Exports />} />
        <Route path="/websites" element={<YourWebsites />} />
        <Route path="/user/settings" element={<AccountSetting />} />
        <Route path="/user/settings/email/verification/:token" element={<AccountSetting />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/contracts" element={<YourContracts />} />
        <Route path="/balance" element={<Balance />} />
        <Route path="/content/articles" element={<Articles />} />
        <Route path="/content/editor" element={<UpsertArticle from='new' />} />
        <Route path="/content/editor/:id" element={<UpsertArticle from='draft' />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default AppMain;
